<div class="epic-confirmation">
	<div class="epic-confirmation__message">
		<epic-form-field>
			<epic-select
				[ngStyle]="{ '--status-colour': conveyanceTypeForm.formGroup.controls['conveyanceType'].value?.colour}"
				[isClearVisible]="false"
				[control]="conveyanceTypeForm.formGroup.controls['conveyanceType']"
				[customSelectedValues]="true">
				<div
					class="epic-select__custom-values"
					selected-values>
					<div class="epic-select__selected">
						<div
							class="epic-select__colour"
							[style.background-color]="conveyanceTypeForm.formGroup.controls['conveyanceType'].value?.colour"></div>
						{{ getItemTranslation(conveyanceTypeForm.formGroup.controls['conveyanceType'].value) }}
					</div>
				</div>
				@for (conveyanceType of conveyanceTypes; track conveyanceType) {
				<epic-option
					[value]="conveyanceType"
					[ngStyle]="{ '--icon-colour': conveyanceType.colour }"
					[selected]="order.conveyance_type?.id === conveyanceType.id"
					class="epic_select__option">
					<div class="epic-select__selected">
						<div
							class="epic-select__colour"
							[style.background-color]="conveyanceType.colour"></div>
						{{ getItemTranslation(conveyanceType) }}
					</div>
				</epic-option>
				}
			</epic-select>
		</epic-form-field>
	</div>
	<div class="epic-confirmation__actions">
		<epic-button
			[text]="confirmButtonText"
			(onClick)="updateConveyanceType()" />
		<epic-button
			[text]="cancelButtonText"
			[isActive]="false"
			(onClick)="cancelUpdateConveyanceType()" />
	</div>
</div>
